export const RFX_QUESTION_TYPE = {
	CHECKBOX: "checkbox",
	DATE: "date",
	FILE: "file",
	SELECT: "select",
	RADIO: "radio",
	TABLE: "table",
	TABLE_ROWS: "table-to-add-rows",
	TEXT: "text",
	TEXTAREA: "textarea",

	// SMART FIELDS
	CORPORATE_DOCUMENTS: "corporate_documents",
	KEY_PERSONNEL: "key_personnel",
	PROJECT_EXPERIENCE: "project_experience",
} as const;

export const RFX_ANSWER_CHOICE_TYPE = {
	OTHER: "other",
	SELECT: "select",
} as const;

export const RFX_SUBMISSION_STATUS = {
	INVITED: "INVITED", // 1
	ACCEPTED: "ACCEPTED", // 2
	SUBMITTED: "SUBMITTED", // 3
	INPROGRESS: "INPROGRESS", // 4
	AWARDED: "AWARDED", // 5
	DECLINE: "DECLINE", // 6
	ON_HOLD: "ON_HOLD", // 7
	UNSUCCESSFUL: "UNSUCCESSFUL", //8
};

export const HAS_ACCEPTED = [
	RFX_SUBMISSION_STATUS.ACCEPTED,
	RFX_SUBMISSION_STATUS.SUBMITTED,
	RFX_SUBMISSION_STATUS.INPROGRESS,
	RFX_SUBMISSION_STATUS.AWARDED,
];

export const HAS_SUBMITTED = [
	RFX_SUBMISSION_STATUS.SUBMITTED,
	RFX_SUBMISSION_STATUS.AWARDED,
	RFX_SUBMISSION_STATUS.UNSUCCESSFUL,
];

export const QUESTION_TYPE_ID = {
	SHORT_ANSWER: 1,
	PARAGRAPH: 2,
	SINGLE_OPTION: 3,
	MULTIPLE_CHOICE: 4,
	DROP_DOWN: 5,
	DATE_SELECTION: 6,
	ADDRESS_FINDER: 7,
	PROJECT_EXPERIENCE: 8,
	KEY_PERSONNEL: 9,
	CORPORATE_DOCUMENTS: 10,
	FILE_UPLOAD: 11,
	TABLE: 12,
	TABLE_ROWS: 13,
} as const;
